import { IBuildingItem, IBuilding } from 'models';
import BuildingThumbnailPlaceholderImg from 'assets/images/building_thumbnail_placeholder.png';

export const getBuildingLocation = (building: IBuilding, showZip = true) => {
  let location = `${building.address}, ${building.city}, ${building.state}`;
  if (showZip) {
    location = `${location}, ${building.zip}`;
  }
  return location;
};

export const getBuildingImageUrl = (building?: IBuilding, placeholderImage = true) => {
  if (!building || !building.thumbnail || !building.thumbnail.url) {
    return placeholderImage ? BuildingThumbnailPlaceholderImg : '';
  }
  return `${building.thumbnail.url}?${building.thumbnail.size}`;
};

interface FilterBuildingItemsProps {
  searchKeyword: string;
  city: string;
  state: string;
  account_name: string;
}

const isLocation = (building: IBuildingItem, keyword: string) =>
  building.location.toLowerCase().includes(keyword.toLowerCase());

const isFloors = (building: IBuildingItem, keyword: string) =>
  `${building.floors} floors`.toLowerCase().includes(keyword.toLowerCase());

const isAccountName = (building: IBuildingItem, keyword: string) =>
  (building.account_name ?? '').toLowerCase().includes(keyword.toLowerCase());

const isFiltered = (building: IBuildingItem, filters: FilterBuildingItemsProps) => {
  const matchesSearch =
    !filters.searchKeyword ||
    isLocation(building, filters.searchKeyword) ||
    isFloors(building, filters.searchKeyword) ||
    isAccountName(building, filters.searchKeyword);

  const matchesCity = !filters.city || (building.city ?? '') === filters.city;
  const matchesState = !filters.state || (building.state ?? '') === filters.state;
  const matchesAccount = !filters.account_name || isAccountName(building, filters.account_name);

  return matchesSearch && matchesCity && matchesState && matchesAccount;
};

export const filterBuildingItems = (
  buildings?: Array<IBuildingItem>,
  filters: FilterBuildingItemsProps = {
    searchKeyword: '',
    city: '',
    state: '',
    account_name: '',
  },
) => {
  if (!buildings || buildings.length === 0) return [];

  const hasActiveFilter = filters.searchKeyword || filters.city || filters.state || filters.account_name;

  if (!hasActiveFilter) return buildings;

  return buildings.filter((building) => isFiltered(building, filters));
};
